module.exports = __webpack_public_path__ + "static/media/car-2.abfa17b7.jpg";